import axios from "axios";

export const API = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api`,
  headers: {
    "Content-Type": "multipart/form-data",
  },
  withCredentials: true,
});


export const KEY = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api`,
  headers: {
    "Accept-Language": "en",
    "Content-Type": "application/x-www-form-urlencoded",
  },
  withCredentials: true,
  // transformRequest: [data =>{
  //   return new URLSearchParams(data).toString()
  // }]
});
